module.exports = __webpack_public_path__ + "img/coupon.27eed6f6.svg";